import {
  DocusignFieldTabLabel,
  DocusignHiddenFieldTabLabel,
  DocusignTaxClassificationLabelMap,
  TaxClassificationType,
  llcTypeOptions,
} from 'src/constants/docusign'
import {
  DocusignProcessResponsePayload,
  DocusignSigningField,
  DocusignSigningFieldRequestItem,
} from 'src/interfaces/docusign'

export const processResponseDocusignSigningFields = (
  signingFields: Array<DocusignSigningField> | null | undefined,
): DocusignProcessResponsePayload => {
  if (!signingFields) {
    return {
      signingFields: null,
      hiddenFields: null,
    }
  }

  const resultSigningFields: Array<DocusignSigningField> = signingFields
    .filter((signingField) => Boolean(DocusignFieldTabLabel[signingField.tabLabel]))
    .map((signingField) => {
      if (signingField.tabLabel === DocusignFieldTabLabel.smartDeliveryCheckboxLease) {
        return {
          ...signingField,
          value: 'true',
        }
      }

      return signingField
    })

  const resultHiddenFields: Array<DocusignSigningField> = signingFields.filter((signingField) =>
    Boolean(
      DocusignHiddenFieldTabLabel[signingField.tabLabel as unknown as DocusignHiddenFieldTabLabel],
    ),
  )

  return {
    signingFields: resultSigningFields,
    hiddenFields: resultHiddenFields,
  }
}

export const processRequestDocusignSigningFields = (
  signingFields: Array<DocusignSigningFieldRequestItem>,
  hiddenFields: Array<DocusignSigningField>,
): Array<DocusignSigningFieldRequestItem> => {
  if (signingFields.length === 0) {
    return []
  }

  const result = [...signingFields]

  const businessTypeHiddenField = generateBusinessTypeField(signingFields, hiddenFields)

  if (businessTypeHiddenField) {
    result.push(businessTypeHiddenField)
  }

  return result
}

export const generateBusinessTypeField = (
  signingFields: Array<DocusignSigningFieldRequestItem>,
  hiddenFields: Array<DocusignSigningField> = [],
): DocusignSigningFieldRequestItem | null => {
  const businessTypeHiddenField = hiddenFields.find(
    (hiddenField) =>
      (hiddenField.tabLabel as unknown as DocusignHiddenFieldTabLabel) ===
      DocusignHiddenFieldTabLabel.businessTypeTextHidden,
  )

  if (!businessTypeHiddenField) {
    return null
  }

  const taxClassificationType = signingFields.find(
    (signingField) => signingField.tabLabel === DocusignFieldTabLabel.taxClassificationType,
  )
  const llcType = signingFields.find(
    (signingField) => signingField.tabLabel === DocusignFieldTabLabel.llcType,
  )
  const otherTaxClassification = signingFields.find(
    (signingField) => signingField.tabLabel === DocusignFieldTabLabel.otherTaxClassification,
  )

  if (!taxClassificationType) {
    return null
  }

  const businessTypePayload: DocusignSigningFieldRequestItem = {
    tabLabel: DocusignHiddenFieldTabLabel.businessTypeTextHidden,
    value: '',
  }

  if (taxClassificationType.value === TaxClassificationType.Other) {
    businessTypePayload.value = otherTaxClassification?.value || ''
  } else if (taxClassificationType.value === TaxClassificationType.Llc) {
    const llcTypeOption = llcTypeOptions.find(
      (llcTypeOption) => llcTypeOption.value === llcType?.value,
    )

    businessTypePayload.value = `${
      DocusignTaxClassificationLabelMap[TaxClassificationType.Llc]
    } - ${llcTypeOption?.label || ''}`
  } else {
    businessTypePayload.value =
      DocusignTaxClassificationLabelMap[taxClassificationType.value as TaxClassificationType] ||
      'N/A'
  }

  return businessTypePayload
}
